<svg enable-background="new 0 0 0 0" id="L9" version="1.1" viewBox="0 0 100 100" x="0px"
     xml:space="preserve" xmlns="http://www.w3.org/2000/svg" y="0px" *ngIf="loader">
  <defs>
    <linearGradient
      [attr.x1]="loader.linearGradientPosition.x1"
      [attr.x2]="loader.linearGradientPosition.x2"
      [attr.y1]="loader.linearGradientPosition.y1"
      [attr.y2]="loader.linearGradientPosition.y2"
      id="linear">
      <stop *ngFor="let stop of loader.gradientColorValues" [attr.offset]="stop.position"
            [attr.stop-color]="stop.color"/>
    </linearGradient>
    <radialGradient [attr.fx]="loader.radialGradientPosition.x"
                    [attr.fy]="loader.radialGradientPosition.y"
                    id="radial">
      <stop *ngFor="let stop of loader.gradientColorValues" [attr.offset]="stop.position"
            [attr.stop-color]="stop.color"/>
    </radialGradient>
  </defs>
  <rect [attr.fill]="loader.color" height="10" width="4" x="20" y="50">
      <animateTransform attributeName="transform"
                        attributeType="xml" begin="0"
                        dur="0.6s"
                        repeatCount="indefinite" type="translate" values="0 0; 0 20; 0 0"/>
    </rect>
  <rect [attr.fill]="loader.color" height="10" width="4" x="30" y="50">
      <animateTransform attributeName="transform"
                        attributeType="xml" begin="0.2s"
                        dur="0.6s"
                        repeatCount="indefinite" type="translate" values="0 0; 0 20; 0 0"/>
    </rect>
  <rect [attr.fill]="loader.color" height="10" width="4" x="40" y="50">
      <animateTransform attributeName="transform"
                        attributeType="xml" begin="0.4s"
                        dur="0.6s"
                        repeatCount="indefinite" type="translate" values="0 0; 0 20; 0 0"/>
    </rect>
</svg>
